import parse from 'html-react-parser';

/**
 * @deprecated Use htmlToReact.tsx
 *
 * libs/shared/v2/utils/htmlToReact/htmlToReact.tsx
 *
 * import htmlToReact from '@shared/v2/utils/htmlToReact';
 */
const htmlToReact = (htmlString) => parse(htmlString);

export default htmlToReact;
